import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '../lib/cn';

const badgeVariants = cva(
  'inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    variants: {
      variant: {
        default: 'border-transparent bg-primary text-primary-foreground shadow hover:bg-primary/80',
        secondary:
          'border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80',
        destructive:
          'border-transparent bg-destructive text-destructive-foreground shadow hover:bg-destructive/80',
        outline: 'text-foreground',
        success:
          'border-transparent bg-[var(--status-success-bg)] text-[var(--status-success-text)]',
        warning:
          'border-transparent bg-[var(--status-warning-bg)] text-[var(--status-warning-text)]',
        error: 'border-transparent bg-[var(--status-alert-bg)] text-[var(--status-alert-text)]',
        info: 'border-transparent bg-[var(--status-info-bg)] text-[var(--status-info-text)]',
        neutral:
          'border-transparent bg-[var(--status-neutral-bg)] text-[var(--status-neutral-text)]',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

// Allowlisted in config-eslint's react-refresh `allowExportNames` (shadcn layout).
// react-doctor-disable-next-line react-doctor/only-export-components
export { Badge, badgeVariants };
